import type { SVGAttributes } from 'react';

export function ShareLinkedInIcon(props: SVGAttributes<SVGSVGElement>) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" {...props} viewBox="0 0 24 24">
			<rect width="24" height="24" fill="#fff" rx="4" />
			<path
				fill="currentColor"
				d="M6 7.614q0-.578.405-.953.406-.375 1.054-.375.638 0 1.031.37.406.38.406.992 0 .555-.394.924-.405.38-1.066.38h-.011q-.638 0-1.031-.38A1.28 1.28 0 0 1 6 7.614m.15 10.1v-7.71h2.572v7.71zm3.997 0h2.571V13.41q0-.404.093-.624.162-.391.492-.663t.828-.272q1.298 0 1.298 1.744v4.12H18v-4.42q0-1.71-.81-2.592-.812-.883-2.144-.883-1.494 0-2.328 1.281v.023h-.011l.011-.023v-1.097h-2.571q.023.37.023 2.298t-.023 5.414"
			/>
		</svg>
	);
}
